import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommonModule } from '@common/common.module';
/* Common Modules */
import { SettingsRouterModule } from '@settings/settings.routes';
/* Components */
import { Components } from '@settings/components';
/* Providers */
import { Services } from '@settings/services';
import { SettingsResolver } from '@settings/settings.resolver';

import { TableModule } from '@app/modules/table/table.module';
import { InvoiceIndexTable } from '@settings/services/tables/invoice-table/invoice-index.table';

import { ImageToggleComponent } from '@app/components/forms/image-toggle/image-toggle.component';
import { PlatformModule } from '@app/platform.module';
import { SettingsFormsModule } from '@forms/settings/settings-forms.module';
import { SettingForms } from '@settings/forms';
import { Views } from '@settings/views';
import { IntegrationCardComponent } from '../../components/integration-card/integration-card.component';
import { KYCKYBRoleWarning } from '../payroll/components/kyc-kyb/kyc-kyb-role-warning/kyc-kyb-role-warning.component';
import { SignInMFASetting } from './views/sign-in/mfa/mfa.component';
import { SignInSSOSetting } from './views/sign-in/sso/sso.component';

@NgModule({
    imports: [
        SettingsRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        TableModule,
        SettingsFormsModule,
        IntegrationCardComponent,
        ImageToggleComponent,
        SignInSSOSetting,
        SignInMFASetting,
        KYCKYBRoleWarning,
    ],
    declarations: [...Views, ...Components, ...SettingForms],
    providers: [...Services, SettingsResolver, InvoiceIndexTable],
})
export class SettingsModule {}
